"use client";

import { last } from "es-toolkit";
import Link from "next/link";
import { usePathname } from "next/navigation";
import React, { useEffect, useState } from "react";
import { LuGem, LuGlobe, LuTrendingUp, LuUser, LuUsers } from "react-icons/lu";

import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { APP_ROUTES } from "@/utils/constants";
import { cn } from "@/utils/lib";

const HEADINGS = [
  {
    value: "trending",
    label: "Trending",
    route: APP_ROUTES.tradeTrending,
    icon: LuTrendingUp,
  },
  {
    value: "launchpad",
    label: "Launchpad",
    route: APP_ROUTES.tradeLaunchpad,
    icon: LuGem,
  },
  {
    value: "activity",
    label: "Activity",
    route: APP_ROUTES.tradeActivity,
    icon: LuGlobe,
  },
  {
    value: "top-traders",
    label: "Top Traders",
    route: APP_ROUTES.tradeTopTraders,
    icon: LuUsers,
  },
  {
    value: "portfolio", // single user page
    label: "Portfolio",
    route: APP_ROUTES.tradePortfolio,
    icon: LuUser,
  },
];

const findActiveTab = (currentSegment?: string) => {
  return (
    HEADINGS.find(({ value }) => value === currentSegment)?.value ||
    HEADINGS[0].value
  );
};

const TradeHeadings = () => {
  const pathname = usePathname();
  const currentSegment = last(pathname.split("/"));
  const [activeTab, setActiveTab] = useState(findActiveTab(currentSegment));

  useEffect(() => {
    if (pathname.includes(APP_ROUTES.tradePortfolio)) {
      setActiveTab("portfolio");
    } else {
      setActiveTab(findActiveTab(currentSegment));
    }
  }, [currentSegment, pathname]);

  return (
    <div
      className="
        flex flex-col items-start justify-between gap-4
        md:flex-row md:items-end md:gap-0
      "
    >
      <Tabs
        defaultValue={activeTab}
        value={activeTab}
        className="w-full text-left"
        onValueChange={setActiveTab}
      >
        <TabsList
          className="
            mb-4 flex justify-center border-0 py-2 opacity-90 backdrop-blur-lg
            md:mb-0 md:justify-start
          "
        >
          {HEADINGS.map(({ value, label, route, icon: Icon }, i) => (
            <TabsTrigger key={value} value={value} className="p-0 text-sm">
              <Link
                href={route}
                className={cn(
                  `flex items-center gap-2 px-3 py-1.5`,
                  i === 0 && "pl-0",
                )}
                title={label}
              >
                <Icon size={20} />
                <span
                  className={cn(
                    `
                      hidden
                      xl:inline
                    `,
                    {
                      inline: activeTab === value,
                    },
                  )}
                >
                  {label}
                </span>
              </Link>
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>
    </div>
  );
};

export default TradeHeadings;
